import { render } from "./NovoPublico.vue?vue&type=template&id=4d8632aa&scoped=true"
import script from "./NovoPublico.vue?vue&type=script&lang=js"
export * from "./NovoPublico.vue?vue&type=script&lang=js"

import "./NovoPublico.vue?vue&type=style&index=0&id=4d8632aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8632aa"]])

export default __exports__